/** Kleiner Ladeindikator, wiederverwendbar in Suspense-Fallbacks. */
export function LoadingSpinner({ fullPage = false }: { fullPage?: boolean }) {
  const spinner = (
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-slate-900 border-t-transparent" />
  )
  if (!fullPage) return spinner
  return (
    <div className="flex h-full w-full items-center justify-center py-16">{spinner}</div>
  )
}
